import { FC, PropsWithChildren } from 'react';
import styled from 'styled-components';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { FormDatePicker, FormField } from '../../../common/form';
import translations from './AlgorithmJoinItemDatePicker.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'algorithm-join-item-date-picker',
);
addTranslations(translations);

export interface AlgorithmJoinItemDatePickerProps extends PropsWithChildren {
  joinIndex: number;
  index: number;
  role: 'source' | 'target';
}

export const AlgorithmJoinItemDatePicker: FC<
  AlgorithmJoinItemDatePickerProps
> = (props) => {
  const { t } = useTranslation();
  const { joinIndex, index, role } = props;
  const name =
    `joins.${joinIndex}.algorithmJoinItems.${index}.${role}Value` as const;

  return (
    <StyledFormField required name={name} label={t('label')}>
      <FormDatePicker name={name} />
    </StyledFormField>
  );
};

const StyledFormField = styled(FormField)`
  min-width: 0;

  > div {
    align-items: center;
    flex-grow: 1;
  }
`;
